import {
  enumPurchaseLoadStatus,
  type PurchaseLoadStatus,
} from '@rematter/frontend-lib-api-client';
import { Badge, cn, ThemeColor } from '@rematter/ui-web';

import { useTranslations } from '../../../i18n/useTranslations';

type TicketStatusBadgeProps = {
  status: PurchaseLoadStatus;
  size?: 'small' | 'xs' | 'default' | 'large';
  className?: string;
  inverted?: boolean;
};

const colorByPurchaseLoadStatus: Record<PurchaseLoadStatus, ThemeColor> = {
  [enumPurchaseLoadStatus.Open]: 'primary',
  [enumPurchaseLoadStatus.Held]: 'warning',
  [enumPurchaseLoadStatus.InventoryComplete]: 'primary',
  [enumPurchaseLoadStatus.PriceComplete]: 'primary',
  [enumPurchaseLoadStatus.Paid]: 'success',
  [enumPurchaseLoadStatus.Voided]: 'failure',
};

//
// ⚛️ ⚛️ ⚛️ TICKET STATUS BADGE ⚛️ ⚛️ ⚛️
//
export const TicketPurchaseLoadStatusBadge = ({
  status,
  size = 'small',
  className,
  inverted,
}: TicketStatusBadgeProps) => {
  const t = useTranslations();

  const labelByPurchaseLoadStatus: Record<PurchaseLoadStatus, string> = {
    [enumPurchaseLoadStatus.Open]: t.scaleTicketPro.statusOpen,
    [enumPurchaseLoadStatus.Held]: t.scaleTicketPro.statusHeld,
    [enumPurchaseLoadStatus.InventoryComplete]:
      t.scaleTicketPro.statusInventoryComplete,
    [enumPurchaseLoadStatus.PriceComplete]:
      t.scaleTicketPro.statusPriceComplete,
    [enumPurchaseLoadStatus.Paid]: t.scaleTicketPro.statusPaid,
    [enumPurchaseLoadStatus.Voided]: t.scaleTicketPro.statusVoided,
  };

  return (
    <Badge
      color={inverted ? 'neutral' : colorByPurchaseLoadStatus[status]}
      size={size}
      className={cn(
        '@TicketPurchaseLoadStatusBadge',
        cn(
          '@TicketStatusBadge',
          inverted && 'bg-abs-white/20 text-abs-white',
          className,
        ),
      )}
    >
      {labelByPurchaseLoadStatus[status]}
    </Badge>
  );
};
